import React from 'react';

interface SidebarToggleProps {
  isOpen: boolean;
  onToggle: () => void;
}

const SidebarToggle: React.FC<SidebarToggleProps> = ({ isOpen, onToggle }) => (
  <button
    type="button"
    className={`chat-sidebar-toggle ${isOpen ? 'is-open' : ''}`}
    onClick={onToggle}
    aria-label={isOpen ? 'Collapse chat sidebar' : 'Expand chat sidebar'}
    aria-expanded={isOpen}
  >
    <svg
      className="chat-sidebar-toggle__icon"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  </button>
);

export default SidebarToggle;
